import { IScheduleBuildEconomicsSetting } from '../../interfaces/ischedule-build-economics-setting';
import { ScheduleBuildSetting } from '../schedule-build-setting';

export class ScheduleBuildEconomicsSettingBase {
  ScheduleBuildEconomicsSettingId: number;
  ScheduleBuildSettingId: number;
  Year: number;
  Oil: number | null;
  NaturalGasLiquids: number | null;
  Gas: number | null;
  LeaseOperatingExpensesOil: number | null;
  LeaseOperatingExpensesNaturalGasLiquids: number | null;
  LeaseOperatingExpensesGas: number | null;
  LeaseOperatingExpenses: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScheduleBuildSetting?: ScheduleBuildSetting;

  constructor(item?: IScheduleBuildEconomicsSetting) {
    if (item) {

      this.ScheduleBuildEconomicsSettingId = item.ScheduleBuildEconomicsSettingId;
      this.ScheduleBuildSettingId = item.ScheduleBuildSettingId;
      this.Year = item.Year;
      this.Oil = item.Oil;
      this.NaturalGasLiquids = item.NaturalGasLiquids;
      this.Gas = item.Gas;
      this.LeaseOperatingExpensesOil = item.LeaseOperatingExpensesOil;
      this.LeaseOperatingExpensesNaturalGasLiquids = item.LeaseOperatingExpensesNaturalGasLiquids;
      this.LeaseOperatingExpensesGas = item.LeaseOperatingExpensesGas;
      this.LeaseOperatingExpenses = item.LeaseOperatingExpenses;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScheduleBuildSetting = new ScheduleBuildSetting(item.ScheduleBuildSetting);
    }
  }
}